module.exports = __webpack_public_path__ + "img/cambiar_habitacion_icon.png";